import React from 'react';
import PaginatedResults from './PaginatedResults';

const App = () => {
  return (
    <div>
      <PaginatedResults />
    </div>
  );
};

export default App;

